import { AlertsState } from './alertsSlice';
import IngestSlice, { IngestState, BQUploadState } from '../ingest/ingestSlice';
import { Action, SelectionAction } from '../';

export const dismiss = (state: AlertsState) => {
  state.alerts.pop();
  return state;
};

export const add = (state: AlertsState, action: any) => {
  state.alerts.push(action.payload);
  return state;
};

export const update = (state:AlertsState,action:any) => {
    if(state.alerts.length < 1) return state;
    const topAlert = state.alerts.pop();
    state.alerts.push({...topAlert, ...action.payload});
}

export const goToViewUploadsPage = (alertState: AlertsState, action: any) => {
  IngestSlice.actions.discardMapping();
  alertState.alerts.pop();
  return alertState;
};

export const dismissUploadSuccess = (alertState: AlertsState, action: any) => {
  alertState.alerts.pop();
  return alertState;
};
